import React from 'react'
import { SwethExchangeInfo } from './SwethExchangeInfo'

export function ExchangeInfo({ unstake }: { unstake?: boolean }) {
  return <SwethExchangeInfo unstake={unstake} />
}
